<style lang="less">
.markdown-editor-wrap {
	display: flex;
	flex-direction: column;
	min-height: 200px;
	overflow: hidden;
	position: relative;
}
.markdown-editor-wrap.has-height {
	min-height: 0;
	box-sizing: border-box;
}
.markdown-editor-wrap.has-height > * {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	align-self: stretch;
}
/* 子组件 mavon-editor 内部的 .v-note-wrapper / .v-note-panel / .v-note-edit（本 style 未 scoped） */
.markdown-editor-wrap.has-height .v-note-wrapper {
	min-height: 0 !important;
	height: 100% !important;
	max-height: 100% !important;
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.markdown-editor-wrap.has-height .v-note-panel {
	min-height: 0 !important;
	flex: 1;
	overflow: hidden;
}
.markdown-editor-wrap.has-height .v-note-edit {
	min-height: 0 !important;
	flex: 1;
	overflow: auto;
}
.v-note-wrapper {
	min-height: 500px;
}
.v-show-content {
	background: #fff !important;
	color: #17233d !important;
	.hljs {
		background: none;
	}
	.doc-mermaid {
		margin: 12px 0;
		padding: 12px;
		background: #fafafa;
		border: 1px solid #e4e7ed;
		border-radius: 8px;
		overflow-x: auto;
		text-align: center;
	}
	.doc-mermaid svg {
		max-width: 100%;
		height: auto;
	}
	img[style*='width'] {
		display: block;
		margin: 0.75em auto;
	}
	video.doc-video {
		max-width: 100%;
		display: block;
		margin: 0.75em 0;
		border-radius: 6px;
		background: #000;
	}
}
.v-note-toolbar {
	z-index: 1000 !important;
	position: relative;
}
/* 工具栏 / 编辑区：跟随系统 --bg1（黑底白字）/ --bg2 */
.markdown-editor-wrap .v-note-wrapper,
.v-note-wrapper.fullscreen {
	background: var(--bg1) !important;
	border-color: var(--border) !important;
	color: var(--text1);
}
.v-note-wrapper.fullscreen {
	z-index: 4000 !important;
}
.markdown-editor-wrap .v-note-op,
.v-note-wrapper.fullscreen .v-note-op {
	background: var(--bg2) !important;
	border-bottom: 1px solid var(--border) !important;
	color: var(--text2);
}
.markdown-editor-wrap .v-note-op .op-icon,
.v-note-wrapper.fullscreen .v-note-op .op-icon {
	color: var(--text2);
}
.markdown-editor-wrap .v-note-op .op-icon:hover,
.v-note-wrapper.fullscreen .v-note-op .op-icon:hover {
	color: var(--text1);
	background: var(--bg1);
}
.markdown-editor-wrap .v-note-op .selected,
.v-note-wrapper.fullscreen .v-note-op .selected {
	color: var(--primary, #2d8cf0);
	background: var(--bg1);
}
.markdown-editor-wrap .v-note-panel,
.markdown-editor-wrap .v-note-edit,
.v-note-wrapper.fullscreen .v-note-panel,
.v-note-wrapper.fullscreen .v-note-edit {
	background: var(--bg1) !important;
	color: var(--text1);
}
/* 预览区固定白底黑字，不跟暗色主题 */
.markdown-editor-wrap .v-note-show,
.v-note-wrapper.fullscreen .v-note-show,
.markdown-editor-wrap .v-show-content,
.v-note-wrapper.fullscreen .v-show-content {
	background: #fff !important;
	color: #17233d !important;
}
.markdown-editor-wrap .v-show-content h1,
.markdown-editor-wrap .v-show-content h2,
.markdown-editor-wrap .v-show-content h3,
.markdown-editor-wrap .v-show-content h4,
.markdown-editor-wrap .v-show-content h5,
.markdown-editor-wrap .v-show-content h6,
.markdown-editor-wrap .v-show-content p,
.markdown-editor-wrap .v-show-content li,
.markdown-editor-wrap .v-show-content blockquote,
.v-note-wrapper.fullscreen .v-show-content h1,
.v-note-wrapper.fullscreen .v-show-content h2,
.v-note-wrapper.fullscreen .v-show-content h3,
.v-note-wrapper.fullscreen .v-show-content h4,
.v-note-wrapper.fullscreen .v-show-content h5,
.v-note-wrapper.fullscreen .v-show-content h6,
.v-note-wrapper.fullscreen .v-show-content p,
.v-note-wrapper.fullscreen .v-show-content li,
.v-note-wrapper.fullscreen .v-show-content blockquote {
	color: #17233d !important;
}
.markdown-editor-wrap .v-show-content a,
.v-note-wrapper.fullscreen .v-show-content a {
	color: #2d8cf0;
}
.markdown-fullscreen-close-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	color: var(--text2, #757575);
	vertical-align: middle;
}
.markdown-fullscreen-close-btn:hover {
	color: #ed4014;
}
.markdown-doc-import-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	color: var(--text2, #757575);
	vertical-align: middle;
}
.markdown-doc-import-btn:hover:not(:disabled) {
	color: var(--text1, #333);
}
.markdown-doc-import-btn:disabled {
	opacity: 0.45;
	cursor: not-allowed;
}
.v-note-edit {
	min-height: 400px;
}
.doc-parse-overlay {
	position: absolute;
	inset: 0;
	z-index: 2000;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	background: rgba(255, 255, 255, 0.72);
	backdrop-filter: blur(6px);
}
.doc-parse-card {
	width: 100%;
	max-width: 320px;
	padding: 28px 24px 24px;
	border-radius: 16px;
	background: #fff;
	box-shadow: 0 12px 40px rgba(45, 140, 240, 0.15), 0 2px 12px rgba(0, 0, 0, 0.06);
	text-align: center;
}
.doc-parse-visual {
	position: relative;
	width: 88px;
	height: 88px;
	margin: 0 auto 18px;
}
.doc-parse-ring {
	position: absolute;
	inset: 0;
	border-radius: 50%;
	border: 2px solid transparent;
}
.doc-parse-ring--outer {
	border-top-color: #2d8cf0;
	border-right-color: rgba(45, 140, 240, 0.25);
	animation: doc-parse-spin 1.4s linear infinite;
}
.doc-parse-ring--inner {
	inset: 10px;
	border-bottom-color: #57a3f3;
	border-left-color: rgba(87, 163, 243, 0.2);
	animation: doc-parse-spin 1.1s linear infinite reverse;
}
.doc-parse-doc {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #2d8cf0;
	animation: doc-parse-float 2s ease-in-out infinite;
}
.doc-parse-scan {
	position: absolute;
	left: 12px;
	right: 12px;
	height: 2px;
	top: 50%;
	background: linear-gradient(90deg, transparent, #57a3f3, transparent);
	box-shadow: 0 0 10px rgba(87, 163, 243, 0.8);
	animation: doc-parse-scan 1.8s ease-in-out infinite;
}
.doc-parse-title {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 14px;
}
.doc-parse-steps {
	list-style: none;
	margin: 0 0 16px;
	padding: 0;
	text-align: left;
}
.doc-parse-steps li {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	color: #c0c4cc;
	padding: 4px 0;
	transition: color 0.3s ease;
}
.doc-parse-steps li.is-active {
	color: #606266;
}
.doc-parse-steps li.is-current {
	color: #2d8cf0;
	font-weight: 500;
}
.doc-parse-step-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #dcdfe6;
	flex-shrink: 0;
	transition: background 0.3s ease, transform 0.3s ease;
}
.doc-parse-steps li.is-active .doc-parse-step-dot {
	background: #57a3f3;
}
.doc-parse-steps li.is-current .doc-parse-step-dot {
	background: #2d8cf0;
	transform: scale(1.3);
	box-shadow: 0 0 0 3px rgba(45, 140, 240, 0.15);
}
.doc-parse-progress {
	height: 4px;
	border-radius: 2px;
	background: #eef2f7;
	overflow: hidden;
	margin-bottom: 10px;
}
.doc-parse-progress-bar {
	height: 100%;
	width: 36%;
	border-radius: 2px;
	background: linear-gradient(90deg, #2d8cf0, #57a3f3, #2d8cf0);
	background-size: 200% 100%;
	animation: doc-parse-progress 1.6s ease-in-out infinite;
}
.doc-parse-hint {
	font-size: 12px;
	color: #909399;
	line-height: 1.5;
}
.doc-parse-fade-enter-active,
.doc-parse-fade-leave-active {
	transition: opacity 0.25s ease;
}
.doc-parse-fade-enter,
.doc-parse-fade-leave-to {
	opacity: 0;
}
@keyframes doc-parse-spin {
	to { transform: rotate(360deg); }
}
@keyframes doc-parse-float {
	0%, 100% { transform: translateY(0); }
	50% { transform: translateY(-3px); }
}
@keyframes doc-parse-scan {
	0%, 100% { transform: translateY(-28px); opacity: 0; }
	20% { opacity: 1; }
	80% { opacity: 1; }
	100% { transform: translateY(28px); opacity: 0; }
}
@keyframes doc-parse-progress {
	0% { transform: translateX(-120%); background-position: 0% 50%; }
	100% { transform: translateX(280%); background-position: 100% 50%; }
}
</style>
<template>
	<div
		class="markdown-editor-wrap"
		:class="{ 'has-height': editorHeight }"
		:style="wrapStyle"
	>
		<mavon-editor
			:value="value"
			:placeholder="placeholder"
			ref="md"
			@imgAdd="$imgAdd"
			@change="change"
			@input="change"
			@fullScreen="handleFullScreenChange"
			:defaultOpen="effectiveDefaultOpen"
			:editable="!preview"
			:toolbarsFlag="!preview"
			:subfield="subfield !== undefined ? subfield : !preview"
			class="markdown-editor-inner"
			:ishljs="true"
			language="json"
			codeStyle="github"
			:tabSize="2"
		>
			<template v-if="!preview" slot="left-toolbar-after">
				<button
					type="button"
					class="op-icon markdown-doc-import-btn"
					title="插入视频"
					:disabled="videoUploading"
					@click="openVideoModal"
				>
					<Icon type="md-videocam" :size="16" />
				</button>
				<button
					type="button"
					class="op-icon markdown-doc-import-btn"
					title="文档导入"
					:disabled="docImporting"
					@click="handleDocImportClick"
				>
					<Icon type="md-document" :size="16" />
				</button>
			</template>
			<template v-if="!preview && closable" slot="right-toolbar-after">
				<button
					v-show="isFullscreen"
					type="button"
					class="op-icon markdown-fullscreen-close-btn"
					title="关闭编辑"
					@click.stop.prevent="handleFullscreenClose"
				>
					<Icon type="md-close" :size="18" />
				</button>
			</template>
		</mavon-editor>
		<input
			v-if="!preview"
			ref="docImportInput"
			type="file"
			class="markdown-doc-import-input"
			:accept="parseableFileAccept"
			@change="handleDocImportChange"
		/>
		<input
			v-if="!preview"
			ref="videoUploadInput"
			type="file"
			class="markdown-doc-import-input"
			:accept="videoFileAccept"
			@change="handleVideoUploadChange"
		/>
		<Modal
			v-model="showVideoModal"
			title="插入视频"
			:mask-closable="false"
			width="480"
		>
			<Form label-position="top">
				<FormItem label="视频地址">
					<Input
						v-model="videoUrl"
						placeholder="输入视频 URL，如 https://example.com/video.mp4"
						clearable
					/>
				</FormItem>
				<FormItem label="或上传视频文件">
					<Button
						icon="ios-cloud-upload-outline"
						:loading="videoUploading"
						@click="openVideoFilePicker"
					>
						选择视频文件
					</Button>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showVideoModal = false">取消</Button>
				<Button type="primary" :loading="videoUploading" @click="confirmVideoInsert">
					插入
				</Button>
			</div>
		</Modal>
		<transition name="doc-parse-fade">
			<div v-if="docImporting" class="doc-parse-overlay">
				<div class="doc-parse-card">
					<div class="doc-parse-visual">
						<div class="doc-parse-ring doc-parse-ring--outer"></div>
						<div class="doc-parse-ring doc-parse-ring--inner"></div>
						<div class="doc-parse-doc">
							<Icon type="md-document" :size="28" />
						</div>
						<div class="doc-parse-scan"></div>
					</div>
					<div class="doc-parse-title">正在解析文档</div>
					<ul class="doc-parse-steps">
						<li
							v-for="(step, index) in parseSteps"
							:key="step"
							:class="{ 'is-active': parseStepIndex >= index, 'is-current': parseStepIndex === index }"
						>
							<span class="doc-parse-step-dot"></span>
							<span>{{ step }}</span>
						</li>
					</ul>
					<div class="doc-parse-progress">
						<div class="doc-parse-progress-bar"></div>
					</div>
					<div class="doc-parse-hint">AI 正在识别文档结构与内容，请稍候</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import {mavonEditor} from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import {
  extendMarkdownItForDocs,
  initDocumentMermaid,
} from '@/pages/core/documents/document-markdown';
import {
  PARSEABLE_FILE_ACCEPT,
  VIDEO_FILE_ACCEPT,
  isParseableFileName,
  parseFileToMarkdown,
  uploadFileToMineru,
} from '@/utils/mineru-parse';

export default {
  name: 'markdown',
  data: function() {
    return {
      content: '',
      html: '',
      configs: {},
      docImporting: false,
      parseableFileAccept: PARSEABLE_FILE_ACCEPT,
      videoFileAccept: VIDEO_FILE_ACCEPT,
      showVideoModal: false,
      videoUrl: '',
      videoUploading: false,
      parseSteps: ['上传文件', '识别版面', '提取文本', '生成 Markdown'],
      parseStepIndex: 0,
      parseStepTimer: null,
      isFullscreen: false,
      defaultFullscreenApplied: false,
    };
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    option: {
      type: Object,
      default: ()=>({}),
    },
    preview: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
    /** 是否双栏（编辑+预览），不传时默认非 preview 模式下为 true */
    subfield: {
      type: Boolean,
      default: undefined,
    },
    /** 编辑器整体高度，如 "400px"、"60vh"、"calc(80vh - 120px)"，不传则使用默认 min-height */
    height: {
      type: [String, Number],
      default: '',
    },
    /** 挂载后默认进入全屏（如知识库编辑） */
    defaultFullscreen: {
      type: Boolean,
      default: false,
    },
    /** 全屏工具栏显示关闭编辑按钮 */
    closable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** 双栏时需 defaultOpen='preview' 才会同时显示编辑与预览 */
    effectiveDefaultOpen() {
      const dual = this.subfield !== undefined ? this.subfield : !this.preview;
      return dual ? 'preview' : (this.preview ? 'preview' : 'edit');
    },
    editorHeight() {
      const h = this.height;
      if (h == null || h === '') return '';
      if (typeof h === 'number') return `${h}px`;
      return String(h);
    },
    wrapStyle() {
      if (!this.editorHeight) return undefined;
      return { height: this.editorHeight };
    },
  },
  components: {
    mavonEditor,
  },
  mounted() {
    this.$nextTick(() => {
      this.setupDocMarkdown();
      this.renderMermaidInPreview();
      this.applyDefaultFullscreen();
    });
  },
  beforeDestroy() {
    this.stopParseStepTimer();
    this.exitFullscreenIfNeeded();
  },
  methods: {
    handleFullScreenChange(status) {
      this.isFullscreen = !!status;
      this.$emit('fullScreen', status);
    },
    applyDefaultFullscreen() {
      if (this.preview || !this.defaultFullscreen || this.defaultFullscreenApplied) return;
      const tryEnter = () => {
        const editor = this.$refs.md;
        if (!editor || typeof editor.toolbar_right_click !== 'function') return false;
        this.defaultFullscreenApplied = true;
        if (!editor.s_fullScreen) {
          editor.toolbar_right_click('fullscreen');
        }
        this.isFullscreen = !!editor.s_fullScreen;
        return true;
      };
      if (!tryEnter()) {
        setTimeout(tryEnter, 80);
      }
    },
    exitFullscreenIfNeeded() {
      const editor = this.$refs.md;
      if (editor && editor.s_fullScreen && typeof editor.toolbar_right_click === 'function') {
        editor.toolbar_right_click('fullscreen');
      }
      this.isFullscreen = false;
    },
    handleFullscreenClose() {
      this.exitFullscreenIfNeeded();
      this.$emit('close');
    },
    startParseStepTimer() {
      this.stopParseStepTimer();
      this.parseStepIndex = 0;
      this.parseStepTimer = setInterval(() => {
        this.parseStepIndex = Math.min(
          this.parseStepIndex + 1,
          this.parseSteps.length - 1,
        );
      }, 1400);
    },
    stopParseStepTimer() {
      if (this.parseStepTimer) {
        clearInterval(this.parseStepTimer);
        this.parseStepTimer = null;
      }
    },
    setupDocMarkdown() {
      const editor = this.$refs.md;
      if (!editor || !editor.markdownIt) return;
      extendMarkdownItForDocs(editor.markdownIt, {withKatex: false});
      if (typeof editor.iRender === 'function') {
        editor.iRender(true);
      }
    },
    renderMermaidInPreview() {
      const editor = this.$refs.md;
      const root = editor && editor.$refs.vShowContent;
      initDocumentMermaid(root);
    },
    // 将图片上传到服务器，返回地址替换到md中
    $imgAdd(pos, $file) {
      this.$cos.upload([$file], {onSuccess: (files)=>{
        if (files && files.length > 0) {
          this.$refs.md.$img2Url(pos, files[0].url);
        }
      }}, {coskey: this.$store.getters['session/session'].coskey});
    },
    change(value, render) {
      // render 为 markdown 解析后的结果
      this.html = render;
      this.$emit('change', value);
      this.$emit('input', value);
      this.$nextTick(() => this.renderMermaidInPreview());
    },
    handleDocImportClick() {
      if (this.docImporting || this.preview) return;
      const input = this.$refs.docImportInput;
      if (input) {
        input.value = '';
        input.click();
      }
    },
    async handleDocImportChange(e) {
      const file = e.target && e.target.files && e.target.files[0];
      if (!file) return;

      if (!isParseableFileName(file.name)) {
        this.$Message.warning('仅支持导入 PDF、Word 及图片文件');
        e.target.value = '';
        return;
      }

      this.docImporting = true;
      this.startParseStepTimer();

      try {
        const mdContent = await parseFileToMarkdown(file);
        if (!mdContent) {
          throw new Error('未解析到有效内容');
        }
        this.insertMarkdownContent(mdContent);
        this.$Message.success('文档已导入');
      } catch (err) {
        this.$Message.error(`文档导入失败：${err.message || err}`);
      } finally {
        this.stopParseStepTimer();
        this.docImporting = false;
        e.target.value = '';
      }
    },
    insertMarkdownContent(mdContent) {
      const editor = this.$refs.md;
      if (!editor) return;

      const textarea = editor.getTextareaDom();
      const content = mdContent.trim();
      if (!content) return;

      const hasContentBefore = textarea && textarea.selectionStart > 0;
      const prefix = hasContentBefore ? `\n\n${content}\n\n` : `${content}\n\n`;

      editor.insertText(textarea, {
        prefix,
        subfix: '',
        str: '',
      });
      editor.iRender();
    },
    openVideoModal() {
      if (this.preview || this.videoUploading) return;
      this.videoUrl = '';
      this.showVideoModal = true;
    },
    openVideoFilePicker() {
      if (this.videoUploading) return;
      const input = this.$refs.videoUploadInput;
      if (input) {
        input.value = '';
        input.click();
      }
    },
    async handleVideoUploadChange(e) {
      const file = e.target && e.target.files && e.target.files[0];
      if (!file) return;

      this.videoUploading = true;
      try {
        const url = await uploadFileToMineru(file);
        this.videoUrl = url;
        this.$Message.success('视频上传成功');
      } catch (err) {
        this.$Message.error(`视频上传失败：${err.message || err}`);
      } finally {
        this.videoUploading = false;
        e.target.value = '';
      }
    },
    confirmVideoInsert() {
      const url = (this.videoUrl || '').trim();
      if (!url) {
        this.$Message.warning('请输入视频地址或上传视频文件');
        return;
      }
      this.insertVideoMarkdown(url);
      this.showVideoModal = false;
      this.videoUrl = '';
    },
    insertVideoMarkdown(url) {
      const editor = this.$refs.md;
      if (!editor) return;
      const textarea = editor.getTextareaDom();
      const snippet = `@[video](${url})`;
      const hasContentBefore = textarea && textarea.selectionStart > 0;
      const prefix = hasContentBefore ? `\n\n${snippet}\n\n` : `${snippet}\n\n`;
      editor.insertText(textarea, {
        prefix,
        subfix: '',
        str: '',
      });
      editor.iRender();
    },

  },
};
</script>
<style lang="less" scoped>
.markdown-doc-import-input {
	display: none;
}
.editor-btn {
	margin-top: 20px;
}

body {
	margin: 0 auto;
	font-family: "Microsoft YaHei", arial, sans-serif;
	color: #444444;
	line-height: 1;
	padding: 30px;
}
@media screen and (min-width: 768px) {
	body {
		width: 748px;
		margin: 10px auto;
	}
}
h1,
h2,
h3,
h4 {
	color: #111111;
	font-weight: 400;
	margin-top: 1em;
}

h1,
h2,
h3,
h4,
h5 {
	font-family: "微软雅黑", Georgia, Palatino, serif;
}
h1,
h2,
h3,
h4,
h5,
p,
dl {
	margin-bottom: 16px;
	padding: 0;
}
h1 {
	font-size: 48px;
	line-height: 54px;
}
h2 {
	font-size: 36px;
	line-height: 42px;
}
h1,
h2 {
	border-bottom: 1px solid #efeaea;
	padding-bottom: 10px;
}
h3 {
	font-size: 24px;
	line-height: 30px;
}
h4 {
	font-size: 21px;
	line-height: 26px;
}
h5 {
	font-size: 18px;
	list-style: 23px;
}
a {
	color: #0099ff;
	margin: 0;
	padding: 0;
	vertical-align: baseline;
}
a:hover {
	text-decoration: none;
	color: #ff6600;
}
a:visited {
	/*color: purple;*/
}
ul,
ol {
	padding: 0;
	padding-left: 24px;
	margin: 0;
}
li {
	line-height: 24px;
}
p,
ul,
ol {
	font-size: 16px;
	line-height: 24px;
}

ol ol,
ul ol {
	list-style-type: lower-roman;
}

/*pre {
    padding: 0px 24px;
    max-width: 800px;
    white-space: pre-wrap;
}
code {
    font-family: Consolas, Monaco, Andale Mono, monospace;
    line-height: 1.5;
    font-size: 13px;
}*/

code,
pre {
	border-radius: 3px;
	background-color: #f7f7f7;
	color: inherit;
}

code {
	font-family: Consolas, Monaco, Andale Mono, monospace;
	margin: 0 2px;
}

pre {
	line-height: 1.7em;
	overflow: auto;
	padding: 6px 10px;
	border-left: 5px solid #6ce26c;
}

pre > code {
	border: 0;
	display: inline;
	max-width: initial;
	padding: 0;
	margin: 0;
	overflow: initial;
	line-height: inherit;
	font-size: 0.85em;
	white-space: pre;
	background: 0 0;
}

code {
	color: #666555;
}

/** markdown preview plus 对于代码块的处理有些问题, 所以使用统一的颜色 */
/*code .keyword {
  color: #8959a8;
}

code .number {
  color: #f5871f;
}

code .comment {
  color: #998
}*/

aside {
	display: block;
	float: right;
	width: 390px;
}
blockquote {
	border-left: 0.5em solid #eee;
	padding: 0 0 0 2em;
	margin-left: 0;
}
blockquote cite {
	font-size: 14px;
	line-height: 20px;
	color: #bfbfbf;
}
blockquote cite:before {
	content: "\2014 \00A0";
}

blockquote p {
	color: #666;
}
hr {
	text-align: left;
	color: #999;
	height: 2px;
	padding: 0;
	margin: 16px 0;
	background-color: #e7e7e7;
	border: 0 none;
}

dl {
	padding: 0;
}

dl dt {
	padding: 10px 0;
	margin-top: 16px;
	font-size: 1em;
	font-style: italic;
	font-weight: bold;
}

dl dd {
	padding: 0 16px;
	margin-bottom: 16px;
}

dd {
	margin-left: 0;
}

table {
	*border-collapse: collapse; /* IE7 and lower */
	border-spacing: 0;
	width: 100%;
}
table {
	border: solid #ccc 1px;
	-moz-border-radius: 6px;
	-webkit-border-radius: 6px;
	border-radius: 6px;
	/*-webkit-box-shadow: 0 1px 1px #ccc;
    -moz-box-shadow: 0 1px 1px #ccc;
    box-shadow: 0 1px 1px #ccc;   */
}
table tr:hover {
	background: #fbf8e9;
	-o-transition: all 0.1s ease-in-out;
	-webkit-transition: all 0.1s ease-in-out;
	-moz-transition: all 0.1s ease-in-out;
	-ms-transition: all 0.1s ease-in-out;
	transition: all 0.1s ease-in-out;
}
table td,
.table th {
	border-left: 1px solid #ccc;
	border-top: 1px solid #ccc;
	padding: 10px;
	text-align: left;
}

table th {
	background-color: #dce9f9;
	background-image: -webkit-gradient(
		linear,
		left top,
		left bottom,
		from(#ebf3fc),
		to(#dce9f9)
	);
	background-image: -webkit-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: -moz-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: -ms-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: -o-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: linear-gradient(to top, #ebf3fc, #dce9f9);
	/*-webkit-box-shadow: 0 1px 0 rgba(255,255,255,.8) inset;
    -moz-box-shadow:0 1px 0 rgba(255,255,255,.8) inset;
    box-shadow: 0 1px 0 rgba(255,255,255,.8) inset;*/
	border-top: none;
	text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
	padding: 5px;
}

table td:first-child,
table th:first-child {
	border-left: none;
}

table th:first-child {
	-moz-border-radius: 6px 0 0 0;
	-webkit-border-radius: 6px 0 0 0;
	border-radius: 6px 0 0 0;
}
table th:last-child {
	-moz-border-radius: 0 6px 0 0;
	-webkit-border-radius: 0 6px 0 0;
	border-radius: 0 6px 0 0;
}
table th:only-child {
	-moz-border-radius: 6px 6px 0 0;
	-webkit-border-radius: 6px 6px 0 0;
	border-radius: 6px 6px 0 0;
}
table tr:last-child td:first-child {
	-moz-border-radius: 0 0 0 6px;
	-webkit-border-radius: 0 0 0 6px;
	border-radius: 0 0 0 6px;
}
table tr:last-child td:last-child {
	-moz-border-radius: 0 0 6px 0;
	-webkit-border-radius: 0 0 6px 0;
	border-radius: 0 0 6px 0;
}

.markdown-body {
	box-shadow: none !important;
}
</style>
